import { StyleSpecification } from 'maplibre-gl';

import { resolveSatellite } from './satellite-providers';

// NOTE : go to https://cloud.maptiler.com/maps/ to grab new ones

export type MapStyle = string | StyleSpecification;
export type MapStyleType = 'street' | 'satellite';
export type MapStyleMap = Record<MapStyleType, MapStyle>;

export const mapStyleMap = (apiKey: string, country?: string | null): MapStyleMap => ({
  // street: `/assets/style-map-vectorielle.json`,
  //street: `https://api.maptiler.com/maps/streets-v2/style.json?key=${apiKey}`,
  street: `https://api.maptiler.com/maps/e3a8f278-7f27-4ed2-9365-3a8899eb3fd5/style.json?key=VUQcYpbULaOSk7n4Y3eT`,
  satellite: resolveSatellite(country, apiKey).style,
});
